import React from 'react';

import { ReactComponent as ChipIcon } from '../../asset/ChipIcon.svg';
import { ReactComponent as CodeIcon } from '../../asset/CodeIcon.svg';
import { ReactComponent as GearIcon } from '../../asset/GearIcon.svg';
import { ReactComponent as NodeIcon } from '../../asset/NodeIcon.svg';
import { ReactComponent as TerminalIcon } from '../../asset/TerminalIcon.svg';
import classNames from './EABDContentCardIcon.module.scss';

export enum ContentCardIconType {
  CODE = 'CODE',
  GEAR = 'GEAR',
  CHIP = 'CHIP',
  NODE = 'NODE',
  TERMINAL = 'TERMINAL',
}

export interface ContentCardIconProps {
  readonly type: ContentCardIconType;
  readonly shouldRender?: boolean;
}

export const ContentCardIcon = React.memo<ContentCardIconProps>((props) => {
  const { type, shouldRender = false } = props;

  const IconElement = React.useMemo((): JSX.Element => {
    switch (type) {
      case ContentCardIconType.CODE:
        return <CodeIcon className={classNames.icon} />;
      case ContentCardIconType.GEAR:
        return <GearIcon className={classNames.icon} />;
      case ContentCardIconType.CHIP:
        return <ChipIcon className={classNames.icon} />;
      case ContentCardIconType.NODE:
        return <NodeIcon className={classNames.icon} />;
      case ContentCardIconType.TERMINAL:
        return <TerminalIcon className={classNames.icon} />;
      default:
        throw new Error('Unknown content card icon type!');
    }
  }, [type]);

  if (!shouldRender) {
    return null;
  }

  return <div className={classNames.container}>{IconElement}</div>;
});
